(function () {
    angular.module('email-engagement-condition.dir', [])
        .directive('emailEngagementCondition', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService','CANVAS_OPTS', '$timeout', emailEngagementCondition]);

    function emailEngagementCondition($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, CANVAS_OPTS, $timeout) {
        return {
            scope: {},
            controller: ['$scope', '$http', function ($scope, $http) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;
                $scope.emailList = helpers.jbContainsSendEmail();
                $scope.wasSave = false;

                //When we save a the form
                $scope.save = function (dummy) {
                    if ($scope.hasErrors() === false) {
                        if(!dummy && $scope.connections.isDummy) {
                            delete $scope.connections.isDummy;
                        }

                        for(var j = 0; j<$scope.connections.data.conditions.length; j++){
                            $scope.connections.data.conditions[j].name = $scope.connections.data.conditions[j].selectedCondition;
                            if(!$scope.connections.data.conditions[j].url) {
                                delete $scope.connections.data.conditions[j].url;
                            }
                        }

                        //Updates the parent to register its children
                        var parentData = helpers.getConnectionById($scope.connections.parent);
                        if (parentData) {
                            parentData.children = [];
                            parentData.children.push($scope.connections.id);
                            helpers.updateConnections(parentData);
                        }

                        //Save to the global canvas object
                        helpers.updateConnections($scope.connections);

                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index > -1) {
                            $rootScope.unsavedData.splice(index, 1);
                        }

                        //Displays th form data
                        $rootScope.$emit('hideConditionEmailEngagementtModal');
                        $scope.displayList = false;
                        //Hides Error
                        $scope.displayError = false;
                        $scope.urlError = false;

                        $scope.displayConditionMenu = [];
                        $scope.displayConditionConnectors = true;

                        var lastElement = $scope.connections;

                        lastElement.children = [];

                        //Create conditions connections
                        if ($rootScope.cElement) {
                            delete $rootScope.cElement;
                            $scope.newlyCreate = false;
                            for (var i = 0; i < $rootScope.loaderData.length; i++) {
                                if ($rootScope.loaderData[i].parent === lastElement.id) {
                                    if($rootScope.loaderData[i].selectedId){
                                       $rootScope.loaderData[i].label = $scope.getConditionListById($rootScope.loaderData[i].selectedId);
                                    }

                                    $scope.rectangleCons.push($rootScope.loaderData[i]);
                                    $scope.setPlumbRectangles(lastElement, $scope.rectangleCons.length - 1);

                                    if($rootScope.loaderData[i].children) {
                                        $scope.hasArrow[$rootScope.loaderData[i].id] = true;
                                        $scope.showConnectionArrow[$rootScope.loaderData[i].id] = false;
                                    }else{
                                        $scope.hasArrow[$rootScope.loaderData[i].id] = false;
                                        $scope.showConnectionArrow[$rootScope.loaderData[i].id] = false;
                                    }

                                    $rootScope.$on('arrowReconnected' + $rootScope.loaderData[i].id, function(evt, id) {
                                        if (id) {
                                            $scope.hasArrow[id] = true;
                                        }
                                    });

                                    $rootScope.$on('hideArrowDelete' + $rootScope.loaderData[i].id, function(evt, id) {
                                        if (id) {
                                            $scope.hasArrow[id] = false;
                                        }
                                    });

                                    $rootScope.$on('showConnectionArrow_' + $rootScope.loaderData[i].id, function (event, condition, id) {
                                        $scope.showConnectionArrow[id] = condition;
                                    });
                                }
                            }
                        } else {

                            // saved for the first time
                            if ($scope.newlyCreate) {
                                $scope.newlyCreate = false;
                                for (var con in $scope.connections.data.conditions) {
                                    var lastTopRectangle;
                                    if (con != 0) {$scope.newlyCreate
                                        lastTopRectangle = $scope.rectangleCons[con - 1].top + 200;
                                    }
                                    $scope.createNewConnection(lastElement, con, lastTopRectangle);
                                }
                            } else {
                                // on update, when save again
                                for (var cu in $scope.connections.data.conditions) {
                                    var lastTopRectangle;
                                    if (cu != 0) {
                                        lastTopRectangle = $scope.rectangleCons[cu - 1].top + 200;
                                    }
                                    if(cu < $scope.rectangleCons.length) {
                                        $scope.rectangleCons[cu].label = $scope.getConditionListById($scope.connections.data.conditions[cu].selectedCondition);
                                        $scope.rectangleCons[cu].selectedId = $scope.connections.data.conditions[cu].selectedCondition;
                                    }else {
                                        $scope.createNewConnection(lastElement, cu, lastTopRectangle);
                                    }
                                }

                                if($scope.connections.data.conditions.length < $scope.rectangleCons.length) {
                                    var dataLeh = $scope.connections.data.conditions.length;
                                    var rectangleLen = $scope.rectangleCons.length;
                                    var rm = rectangleLen - dataLeh;
                                    var spliced = $scope.rectangleCons.splice(dataLeh, rm);

                                    for(var i = 0; i<spliced.length; i++) {
                                        var shapeDelete, el, arrowDelete, arrowDeleteTarget, loopDeleteTarget;

                                        shapeDelete = angular.element(document.querySelector('#' + spliced[i].id));
                                        arrowDelete = angular.element(document.querySelector('#' + spliced[i].id + '-center'));
                                        arrowDeleteTarget = angular.element(document.querySelector('#' + spliced[i].id +'-center-target'));
                                        loopDeleteTarget = angular.element(document.querySelector('#' +  spliced[i].id +'-center-looping'));

                                        jsPlumb.detachAllConnections(shapeDelete);
                                        jsPlumb.detachAllConnections(arrowDelete);
                                        jsPlumb.detachAllConnections(arrowDeleteTarget);
                                        jsPlumb.detachAllConnections(loopDeleteTarget);

                                        shapeDelete.remove();
                                        el = helpers.deleteConnection(spliced[i]);

                                        if (el.deleted) {
                                            for (var j = 0; j < $rootScope.connections.length; j++) {
                                                if ($rootScope.connections[j].parent === el.elem.id) {
                                                    delete $rootScope.connections[j].parent;
                                                }
                                            }
                                            var parentCon = helpers.getConnectionById(el.elem.parent);
                                            if(parentCon.children) {
                                                var idx = parentCon.children.indexOf(el.elem.id);
                                                if(idx > -1) {
                                                    parentCon.children.splice(idx, 1);
                                                }
                                            }
                                        }
                                    }

                                }
                            }

                        }

                        for (var i = 0; i < $scope.rectangleCons.length; i++) {
                            $scope.rectangleCons[i].dataIndex = i;
                            $scope.displayPlus[i] = true;
                            if(lastElement){
                                if(lastElement.children.indexOf($scope.rectangleCons[i].id) === -1){
                                    lastElement.children.push($scope.rectangleCons[i].id);
                                }
                                    helpers.updateConnections(lastElement);
                            }
                            //Save to the global canvas object
                            helpers.updateConnections($scope.rectangleCons[i]);
                        }

                        //Save Journey to template
                        canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections),  $scope.isElegibleForUpdate);

                        if ($scope.isElegibleForUpdate) {
                            $scope.wasSave = true;
                            $timeout(() => {
                                $scope.wasSave = false;
                            }, 1500);
                        }

                        //Set Back to autoSave
                        $scope.isElegibleForUpdate = true;
                        //Remove Activate Error since its being able to save
                        $scope.displayActivateError = false;
                        $scope.displayErrorBlink = false;
                    }else {

                        $scope.displayList = true;
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.601'));

                        if($scope.tempConn) {
                            $scope.connections = angular.copy($scope.tempConn);
                        }
                    }
                };

                $scope.createNewConnection = function(lastElement, con, lastTopRectangle) {
                    var now = new Date(),
                        last,
                        idN;

                    $scope.rectangleCons.push({
                        id: 'element_' + now.getTime() + con,
                        top: (con == 0) ? (lastElement.top + 45) : lastTopRectangle,
                        left: lastElement.left + 250,
                        type: 'RectangleConnection',
                        data: {},
                        elemClass: 'rectangle-connector',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#FF7F57',
                        //Select first list element as label
                        selectedId: $scope.connections.data.conditions[con].selectedCondition,
                        label: $scope.getConditionListById($scope.connections.data.conditions[con].selectedCondition),
                        elemName: 'EmailEngagementConnector'
                    });

                    last = $scope.rectangleCons.length - 1;
                    idN = $scope.rectangleCons[last].id;
                    $scope.hasArrow[idN] = false;
                    $scope.showConnectionArrow[idN] = false;

                    $rootScope.$on('arrowReconnected' + idN, function(evt, id) {
                        if (id) {
                            $scope.hasArrow[id] = true;
                        }
                    });

                    $rootScope.$on('hideArrowDelete' + idN, function(evt, id) {
                        if (id) {
                            $scope.hasArrow[id] = false;
                        }
                    });

                    $rootScope.$on('showConnectionArrow_' + idN, function (event, condition, id) {
                        $scope.showConnectionArrow[id] = condition;
                    });

                    $scope.setPlumbRectangles(lastElement, con);

                };
                //Set up the rectangle connections
                $scope.setPlumbRectangles = function (lastElement, con) {
                    $timeout(function () {
                        plumbService.connectElements(lastElement, $scope.rectangleCons[con]);
                    }, 0);
                };

                $scope.hasErrors = function() {
                    $scope.hasError = false;
                    $scope.emailError = false;

                    if(!$scope.connections.data.emailNode || $scope.connections.data.emailNode === ''){
                        $scope.emailError = true;
                        $scope.hasError = true;
                        $rootScope.$emit('displayConditionEmailEngagementError', $scope.emailError);
                    }

                    for(var item in $scope.connections.data.conditions){
                        $scope.conditionError[parseInt(item)] = false;
                        if($scope.connections.data.conditions[item].selectedCondition === "" || !$scope.connections.data.conditions[item].selectedCondition) {
                            $scope.conditionError[parseInt(item)] = true;
                            $scope.hasError = true;
                            $rootScope.$emit('displayConditionEmailEngagementError', $scope.emailError, $scope.conditionError[parseInt(item)], item);
                        }
                    }

                    if($scope.hasError) {
                        var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                        if (index === -1) {
                            $rootScope.unsavedData.push($scope.connections.id);
                        }
                    }

                    return $scope.hasError;
                };

                $scope.getConditionListById = function (prop) {
                    var propOrDefault = prop || 'hasOpened';
                    return {
                        hasOpened: $scope.translate('canvas.condition.emailEngagement.hasOpened'),
                        hasNotOpened: $scope.translate('canvas.condition.emailEngagement.hasNotOpened'),
                        hasClicked: $scope.translate('canvas.condition.emailEngagement.hasClicked'),
                        hasNotClicked: $scope.translate('canvas.condition.emailEngagement.hasNotClicked')
                    }[propOrDefault];
                };

                $scope.setLastElem = function(evt) {
                    var elemId = $(evt.target).parents('div.shape').attr('id');
                    plumbService.setLastElemClicked(elemId);
                };

                $scope.toggleConnectionMenu = function (event) {
                    //Check if form data is filled and a connection exists as only one is allowed
                    if (helpers.checkIfIsConnected(event.target.parentNode.id)) {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.602'));
                    }
                    else {
                        if ($('#' + event.target.parentNode.id).find('.action-conditions').inlineStyle('display') === 'none') {
                            //remove the hidden style
                            $('#' + event.target.parentNode.id).find('.action-conditions').show();
                            $scope.displaySubMenu = true;
                            $scope.displayList = false;
                            $rootScope.$emit('hideConditionEmailEngagementtModal');
                            $scope.$broadcast('setMenuDefaults');
                        } else {
                            var index = $rootScope.unsavedData.indexOf($scope.connections.id);
                            if (index > -1) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.611'));
                                $rootScope.$emit('displayConditionEmailEngagementModal', $scope.connections);
                                $scope.displaySubMenu = false;
                            } else if ($scope.hasErrors() === true) {
                                $rootScope.$emit('errorMsg', $scope.translate('canvas.error.603'));
                                $rootScope.$emit('displayConditionEmailEngagementModal', $scope.connections);
                                $scope.displaySubMenu = false;
                            } else if ($scope.displaySubMenu === false) {
                                $scope.displaySubMenu = true;
                                $scope.displayList = false;
                                $rootScope.$emit('hideConditionEmailEngagementtModal');
                                $scope.$broadcast('setMenuDefaults');
                            }
                            else {
                                $scope.displaySubMenu = false;
                                $scope.displayList = false;
                                $rootScope.$emit('hideConditionEmailEngagementtModal');
                            }
                        }
                    }
                };

                $scope.showTipModal = () => {
                    // displays tip modal
                    $rootScope.$emit('displayConditionEmailEngagementModal', $scope.connections, true);
                };

                //Cancel Button
                $scope.cancel = function () {
                    //Hide Menu
                    $scope.displayList = false;
                    //Hide Error
                    $scope.displayError = false;

                    if($scope.connections) {
                        var conn = helpers.getStorageConnectionById($scope.connections.id);
                        if(conn) {
                            $scope.connections.data = conn.data;
                        }
                    }
                };

                $scope.config = function (evt) {
                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left'));

                    // check if being dragged and update position
                    if(newTop !== $scope.connections.top || $scope.connections.left !== newLeft){
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionEmailEngagementtModal');
                        //update rootScope position
                        var wasUpdated = helpers.updatePos($scope.connections.id, newTop, newLeft);
                        // To check if the element has been saved or not in the rootScope
                        if(!wasUpdated){
                            $scope.connections.top = newTop;
                            $scope.connections.left = newLeft;
                        }
                        return false;
                    }
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                        $scope.displayConditionMenu = [];
                        $rootScope.$emit('displayConditionEmailEngagementModal', $scope.connections);
                    } else {
                        $scope.displayList = false;
                        $rootScope.$emit('hideConditionEmailEngagementtModal');
                    }
                    //Hide Error
                    $scope.displayError = false;
                    $scope.displaySubMenu = false;
                };

                $scope.$on('closeConfigMenus', function () {
                    if ($scope.displayConditionMenu) {
                        var rectangleMenu = $scope.displayConditionMenu.length > 0;
                    }

                    if ($scope.displayList || $scope.displaySubMenu || rectangleMenu) {
                        $scope.cancel();
                        $scope.displaySubMenu = false;
                        $scope.displayConditionMenu = [];
                        $scope.contMenuConfigs = 0;
                    }
                });

                $scope.parseDescription = function (id, complete) {
                    var eName,
                        completeName;

                    if (!id) {
                        return $scope.translate('commons.enterDetails');
                    }
                    for(var i = 0; i < $scope.emailList.length; i++) {
                        if($scope.emailList[i].id === id) {
                            completeName = $scope.emailList[i].name;
                            break;
                        }
                    }

                    if (completeName && completeName.length > 15) {
                        eName = completeName.slice(0, 15) + '...';
                    }  else if ( completeName && completeName.length < 15) {
                        eName = completeName;
                    }

                    if (complete) {
                        return completeName;
                    }

                    return eName;
                };

                $scope.toggleConnectionRectangle = function (event, index) {
                    $scope.displayConditionMenu = [];

                    //Show form menu
                    if ($scope.displayConditionMenu[index] === false || !$scope.displayConditionMenu[index]) {
                        $scope.displayConditionMenu[index] = true;
                        $('#' + event.target.parentNode.id).find('.action-conditions').show().prev().show();
                    } else {
                        $scope.displayConditionMenu[index] = false;
                    }
                };

                $rootScope.$on('deletedEmailEngagement', function(evt, id) {
                    if(!$scope.hasOwnProperty('connections')){
                        return;
                    }
                    if($scope.connections.id === id) {
                        for (var i = 0; i < $rootScope.connections.length; i++) {
                            for (var j = 0; j < $scope.connections.children.length; j++) {
                                if ($rootScope.connections[i].id === $scope.connections.children[j]) {
                                    plumbService.deleteElements($rootScope.connections[i]);
                                }
                            }
                        }
                    }
                });

                $scope.updateRectPos = function(evt) {

                    var newTop = parseInt($(evt.currentTarget).inlineStyle('top')),
                        newLeft = parseInt($(evt.currentTarget).inlineStyle('left')),
                        id = evt.currentTarget.id,
                        con = helpers.getConnectionById(id);

                    // check if being dragged and update position
                    if (newTop !== con.top || con.left !== newLeft) {
                        //update rootScope position
                        helpers.updatePos(id, newTop, newLeft);
                    }
                };

                $rootScope.$on('emailDeleted', function(evt, Id) {
                    if($scope.connections && $scope.connections.data.emailNode === Id) {
                        $scope.connections.data.emailNode = '';
                        $scope.save();
                        $scope.emailList = helpers.jbContainsSendEmail();
                        $scope.displayList = true;
                        helpers.updateConnections($scope.connections);
                        canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections),  true);
                    }
                });

                $rootScope.$on('emailUpdated', function(evt, Id) {
                    if(Id) {
                        $scope.emailList = helpers.jbContainsSendEmail();
                    }
                });

                $scope.$watch('connections', (conn) => {
                    if(conn && conn.children && conn.children.length) {
                        $scope.disAllowDrag = helpers.validateDragging(conn);
                    } else if(conn && !conn.children) {
                        $scope.disAllowDrag = true;
                    }
                });
            }],
            link: function (scope, elem, attr) {
                //Scope data initialization
                scope.newlyCreate = true;
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.conditionError = [];
                scope.displayPlus = [];
                scope.selectUrl = [];
                scope.rectangleCons = [];
                scope.isElegibleForUpdate = true;
                scope.hasArrow = {};
                scope.showConnectionArrow = {};

                //load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections){
                        if(document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    scope.isElegibleForUpdate = false;

                    var template = $templateCache.get('conditions/email-engagement');

                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveConditionEmailEngagementData' + scope.connections.id, function(evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    if(scope.connections && scope.connections.children && scope.connections.children.length) {
                        $timeout(() => {
                            scope.disAllowDrag = helpers.validateDragging(scope.connections);
                        }, 1000)
                    } else if(scope.connections && !scope.connections.children) {
                        scope.disAllowDrag = true;
                    }

                    scope.save(true);
                }

                $(elem).click(function (evt) {
                    scope.emailList = helpers.jbContainsSendEmail();

                    if(!scope.emailList){
                        $timeout(function() {
                            scope.$emit('errorMsg', scope.translate('canvas.error.606'));
                        }, 0);
                        return;
                    }

                    $rootScope.activePlus = false;

                    scope.newlyCreate = true;
                    scope.displayError = false;
                    scope.displaySubMenu = false;
                    scope.conditionError = [];
                    scope.displayPlus = [];
                    scope.selectUrl = [];
                    scope.rectangleCons = [];
                    scope.hasArrow = {};
                    scope.showConnectionArrow = {};

                    //Load Template
                    var template = $templateCache.get('conditions/email-engagement'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);

                    if(!lastElement) {
                        return false;
                    }

                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: (lastElement.type == 'RectangleConnection') ? (lastElement.top - 43) : lastElement.top,
                        left: lastElement.left + 250,
                        type: 'Condition',
                        data: {
                            emailNode: undefined,
                            conditions: [],
                            url: undefined
                        },
                        elemClass: attr.$attr,
                        elemName: 'EmailEngagement',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#FF7F57'
                    };

                    //start condition 1
                    scope.connections.data.conditions.push({
                        label: scope.translate(`canvas.condition.emailEngagement.conditionLabel.1`),
                        selectedCondition: '',
                    });


                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });

                    // keep track of what has been saved, for activation
                    $rootScope.unsavedData.push(scope.connections.id);

                    $rootScope.$on('activateErr_' + scope.connections.id, function(evt, display) {
                        scope.displayActivateError = display;
                        scope.displayErrorBlink = false;
                    });

                    $rootScope.$on('emptyErr_' + scope.connections.id, function(evt, display) {
                        scope.displayErrorBlink = display;
                        scope.displayActivateError = false;
                    });

                    $rootScope.$on('saveUnsavedData' + scope.connections.id, function() {
                        scope.isElegibleForUpdate = false;
                        scope.save();
                        scope.isElegibleForUpdate = true;

                        if(scope.hasError) {
                            $timeout(function() {
                                $rootScope.$emit('displayConditionEmailEngagementModal', scope.connections);
                                scope.displayList = true;
                            }, 250)
                        }
                    });

                    //Hide hide menus
                    $rootScope.$emit('closeMenus', true);

                    plumbService.connectElements(lastElement, scope.connections);

                    //List modal display new modals
                    $rootScope.$emit('displayConditionEmailEngagementModal', scope.connections);

                    $rootScope.$on('saveConditionEmailEngagementData' + scope.connections.id, function(evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the email engagement node
                    $rootScope.$on('deleteEmailEngagementNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });
                });

                scope.deleteElement = function () {
                    scope.rectangleCons = [];
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;

                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }

                    plumbService.deleteElements(scope.connections);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry' ) {
                        $rootScope.activePlus = true;
                    }else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function(rectangle) {
                    if(rectangle.hasOwnProperty('children')) {
                        scope.hasArrow[rectangle.id] = false;
                        scope.showConnectionArrow[rectangle.id] = false;
                        plumbService.deleteArrows(rectangle);
                    }
                };
            }
        };
    }
}());




// WEBPACK FOOTER //
// ./app/directives/canvas_directives/email-engagement.js